<template>
    <div class="chat-window-container">
        <h2 class="content-title">
            会话窗口和形象
        </h2>
        <div class="content-main" v-if="!isLoading">
            <div
                v-if="tabList.length"
                class="page-container"
            >
                <v-tabs v-model="selectTab" @change="handleChangeTab">
                    <v-tab
                        v-for="tab in tabList"
                        :key="tab.index"
                        :value="tab.index"
                    >
                        {{ tab.text }}
                    </v-tab>
                </v-tabs>
                <div
                    v-if="selectTab === 0"
                    class="page-content"
                >
                    <web-tab-page :channelType="0" :hasMigrated="hasMigrated" />
                </div>
                <div
                    v-if="selectTab === 1"
                    class="page-content"
                >
                    <qq-config-tab-page />
                </div>
                <div
                    v-if="selectTab === 2"
                    class="page-content"
                >
                    <Wxkf-Config />
                </div>
                <div
                    v-if="selectTab === 3"
                    class="page-content"
                >
                    <web-tab-page :channelType="1" :hasMigrated="hasMigrated" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import checkChannel from '@/utils/checkChannel';
import Utils from 'src/common/utils';
import WxkfConfig from 'src/components/chatWindow/index';
import WebTabPage from '../../web-tab-page';
import QqConfigTabPage from '../../qq-config-tab-page/index';
import { isSessionWindowStyleMigrate } from '@/cgi/getWhiteList';
// import WxkfConfig from './components/wxkf-config/index';

export default {
    components: {
        WebTabPage,
        QqConfigTabPage,
        WxkfConfig,
    },
    inject: ['context'],
    data() {
        let tab = parseInt(Utils.getQueryString('tab'), 10);
        if (Number.isNaN(tab) || tab > 3 || tab < 0) {
            tab = 0;
        }
        const { data = {} } = window.pageData || {};

        return {
            isCommercial: !!parseInt(data.isCommercial || 0, 10),
            // 当前选中的tab
            selectTab: tab,
            hasMigrated: false, // 会话互动导航是否已经迁移
            isLoading: true,
        };
    },
    computed: {
        channelIds() {
            return this.context.channelIds;
        },
        isSsc() {
            return this.context.isSsc;
        },
        // 当前tab列表
        tabList() {
            const tabList = [];
            if (checkChannel.checkChannelInData([3], this.channelIds)) {
                tabList.push({
                    index: 0,
                    text: '网页会话',
                });
            }

            if (checkChannel.checkChannelInData([10], this.channelIds) && this.hasMigrated && !this.isSsc) {
                tabList.push({
                    index: 3,
                    text: '小程序插件',
                });
            }

            if (!checkChannel.checkChannelNotInData([1, 2], this.channelIds)) {
                if (!this.isCommercial && !this.isSsc) {
                    tabList.push({
                        index: 1,
                        text: 'QQ会话',
                    });
                }
            }

            if (checkChannel.checkChannelInData([8], this.channelIds) && !this.isSsc) {
                tabList.push({
                    index: 2,
                    text: '微信客服',
                });
            }

            return tabList;
        },
    },
    watch: {
        tabList(val) {
            // 默认选中第一个
            if (val && val.length === 1) {
                this.selectTab = val[0].index;
            }
            // 兜底逻辑 存在wpa侧可以配置 但是会话窗口与形象中没有对应tab 比如QQ会话 在这里还判断了是否是商通套餐
            // 这种情况从wpa侧跳转过来无法选中对应的tab 就默认选中第一个tab
            const existsTab = val.find((item) => item.index === this.selectTab);
            if(!existsTab) {
                this.selectTab = val[0].index;
            }
        },
    },
    created() {
        if (this.$route.query.tab === 'miniPlugin') {
            this.selectTab = 3;
        } else if(this.$route.query.tab === 'web') {
            this.selectTab = 0;
        }
        isSessionWindowStyleMigrate()
            .then((val) => {
                this.hasMigrated = val;
            })
            .catch((e) => {
                console.log('获取会话互动导航迁移状态失败', e);
            })
            .finally(() => {
                // 获取会话互动导航迁移状态请求结束后再加载tab及相关页面
                // bugfix: https://tapd.woa.com/tapd_fe/10109441/bug/detail/1010109441132964277
                this.isLoading = false;
            });
    },
    methods: {
        handleChangeTab() {
            this.$router.replace({ query: {} });
        }
    },
};
</script>

<style lang="less">
.sub-title {
    font-size: 16px;
    line-height: 26px;
}

.page-section {
    &--qq {
        padding: 30px 0;
    }
}
</style>
